/***    AhaCursor.js
 *
 *      Animated cursors for use on CreateJS stages
 */

function AhaCursor(callback, hidden) {
    /* .spritefile - The image containing all the cursor frames */
    this.spriteFile = thisGame.supportMedia('gw/cursor-frames.png');

    /* .update - Whether the nominal cursor position has been changed since it was last read */
    this.update = false;

    /* .loadedCallback - The caller's function to call when loading is complete */
    this.loadedCallback = callback;

    /*  .hidden - Set this when the pointer should not be visible, for instance, while the real mouse
        co-ordinates are off-screen. This must be false, and usePointer true, for the cursor to be visible.
     */
    this.hidden = hidden || false;

    /* .usePointer - Set this after a mouseover has been detected, indicating a real mouse is in use.
    */
    this.usePointer = false;

    /* .frameData - The data that defines the cursor sprites */
    var frameData = {
        /* ..frames - Frame information (x, y, w, h, 0, cx, cxy) grouped by animation */
        frames: [
            // default 0-3
            [1, 76, 20, 20], [1, 96, 20, 20], [1, 116, 20, 20], [1, 136, 20, 20],
            // action 4-5
            [1, 1, 32, 37], [1, 38, 32, 37], // [250, 150, 32, 37], [250, 187, 32, 37],
            // go 6
            [1, 195, 24, 24, 0, 6, 0],
            // examine 7
            [84, 1, 52, 56, 0, 14, 14],
            // hourglass 8
            [1, 220, 17, 27, 0, 8, 13],
            // take 9-10
            [220, 1, 28, 38, 0, 0, 9], [220, 39, 28, 38, 0, 0, 9],
            // pay 11
            [34, 186, 32, 37, 0, 4, 3],
            // pencil-blue 12
            [138, 98, 21, 21, 0, 0, 21],
            // pencil-white 13
            [138, 119, 21, 21, 0, 0, 21],
            // pencil-black 14
            [138, 140, 21, 21, 0, 0, 21],
            // pencil-red 15
            [138, 161, 21, 21, 0, 0, 21],
            // pencil-yellow 16
            [138, 182, 21, 21, 0, 0, 21],
            // turn 17-20
            [303, 1, 53, 35, 0, 10, 35], [303, 36, 53, 35, 0, 10, 35], [303, 71, 53, 35, 0, 10, 35], [303, 106, 53, 35, 0, 10, 35],
            // turn-cw 21-24
            [249, 1, 53, 35, 0, 43, 35], [249, 36, 53, 35, 0, 43, 35], [249, 71, 53, 35, 0, 43, 35], [249, 106, 53, 35, 0, 43, 35],
            // qturn 25-28
            [169, 1, 50, 31, 0, 0, 6], [169, 32, 50, 31, 0, 0, 6], [169, 63, 50, 31, 0, 0, 6], [169, 94, 50, 31, 0, 0, 6],
            // qturn-cw 29-32
            [169, 126, 50, 31, 0, 50, 6], [169, 157, 50, 31, 0, 50, 6], [169, 188, 50, 31, 0, 50, 6], [169, 219, 50, 31, 0, 50, 6],
            // left 33
            [34, 156, 34, 29],
            // right 34
            [34, 224, 34, 29, 0, 34, 6],
            // down 35
            [1, 157, 27, 37, 0, 9, 36],
            // up 36
            [84, 208, 28, 37, 0, 11, 0],
            // left-mini 37-40
            [34, 115, 19, 10, 0, 0, 4], [34, 125, 19, 10, 0, 0, 4], [34, 135, 19, 10, 0, 0, 4], [34, 145, 19, 10, 0, 0, 4],
            // right-mini 41-44
            [54, 115, 19, 10, 0, 19, 4], [54, 125, 19, 10, 0, 19, 4], [54, 135, 19, 10, 0, 19, 4], [54, 145, 19, 10, 0, 19, 4],
            // down-mini 45-48
            [22, 76, 10, 19, 0, 4, 19], [22, 95, 10, 19, 0, 4, 19], [22, 114, 10, 19, 0, 4, 19], [22, 133, 10, 19, 0, 4, 19],
            // up-mini 49-52
            [220, 78, 10, 19, 0, 4, 0], [220, 95, 10, 19, 0, 4, 0], [220, 114, 10, 19, 0, 4, 0], [220, 113, 10, 19, 0, 4, 0],
            // down-left 53
            [34, 1, 49, 30, 0, 2, 23],
            // down-right 54
            [34, 32, 46, 33, 0, 45, 32],
            // out 55-56
            [138, 1, 30, 48, 0, 6, 13], [138, 49, 30, 48, 0, 6, 13],
            // in-left 57
            [34, 66, 25, 22],
            // in-right 58
            [34, 89, 22, 25, 0, 19, 0],
            // out-left 59-60
            [84, 58, 50, 37, 0, 5, 34], [84, 95, 50, 37, 0, 5, 34],
            // out-right 61-62
            [84, 133, 51, 37, 0, 48, 33], [84, 170, 51, 37, 0, 48, 33],
            // next 63
            [235, 147, 57, 45, 0, 54, 22],
            // prev 64
            [235, 193, 58, 47, 0, 0, 22]
        ],
        /* ..animations - The frames to be includes for each animation on a CreateJS spritesheet, and its speed */
        animations: {
            default: {frames: [0, 3], speed: 0.2},
            action: {frames: [4, 5], speed: 0.2},
            go: {frames: [6]},
            examine: {frames: [7]},
            hourglass: {frames: [8]},
            take: {frames: [9, 10], speed: 0.2},
            pay: {frames: [11]},
            pencilBlue: {frames: [12]},
            pencilWhite: {frames: [13]},
            pencilBlack: {frames: [14]},
            pencilRed: {frames: [15]},
            pencilYellow: {frames: [16]},
            turn: {frames: [17, 20], speed: 0.2},
            turnCw: {frames: [21, 24], speed: 0.2},
            qturn: {frames: [25, 28], speed: 0.2},
            qturnCw: {frames: [29, 32], speed: 0.2},
            left: {frames: [33]},
            right: {frames: [34]},
            down: {frames: [35]},
            up: {frames: [36]},
            leftMini: {frames: [37, 40], speed: 0.2},
            rightMini: {frames: [41, 44], speed: 0.2},
            downMini: {frames: [45, 48], speed: 0.2},
            upMini: {frames: [49, 52], speed: 0.2},
            downLeft: {frames: [53]},
            downRight: {frames: [54]},
            out: {frames: [55, 56], speed: 0.2},
            inLeft: {frames: [57]},
            inRight: {frames: [58]},
            outLeft: {frames: [59, 60], speed: 0.2},
            outRight: {frames: [61, 62], speed: 0.2},
            next: {frames: [63]},
            prev: {frames: [64]}
        }
    };

    /* q - Create a dedicated load queue for the cursor */
    var q = new createjs.LoadQueue(true);

    /*  Set up a 'complete' event handler for the image load */
    q.on('complete', function () {
        /* Use the newly-preloaded image as the source of the sprites */
        frameData.images = [q.getResult('cursors')];

        /* .artFingerFrames - The SpriteSheet object from which the cursor sprite gets its bitmap */
        this.artFingerFrames = new createjs.SpriteSheet(frameData);

        /* .finger - The sprite DisplayObject, set initially to the default AHA arrow cursor */
        this.finger = this.cursorSprite('default'); // new createjs.Sprite(this.artFingerFrames, 'default');

        /* .mounted - The cursor is not yet mounted on a stage */
        this.mounted = false;

        /* Invoke the callback function specified by the cursor owner's */
        this.loadedCallback();
    }, this);

    /* Start loading the cursor sprites */
    q.loadFile({id: 'cursors', src: this.spriteFile});
}

/** cursorSprite - Return a new sprite DisplayObject for the given cursor slug (e.g. 'default'), setting its x/y as
 *  well if they are also specified.
 */
AhaCursor.prototype.cursorSprite =
    function (cursorType, x, y) {
        var sprite = new createjs.Sprite(this.artFingerFrames, cursorType);

        if (!Aha.empty(y))
            return Aha.put(sprite, x, y, cursorType + '-sprite');
        else
            return sprite;
    };

/** put - Place the hotspot of the cursor at the given co-ordinates on the canvas - unused, I think
 */
AhaCursor.prototype.put =
    function (x, y) {
        if (x != this.x || y != this.y) {
            this.x = x;
            this.y = y;
            Aha.put(this.finger, x, y, 'cursor');
        }
    };

/** changed - Return true if the cursor is mounted and has either moved or had its .update property set
 */
AhaCursor.prototype.changed =
    function () {
        if (!this.mounted)
            return false;
        else if (this.update) {
            this.update = false;
            return true;
        }
        else {
            var stage = this.stage;
            return stage.mouseX != this.x || stage.mouseY != this.y;
        }
    };

/** updatePosition - Reposition the cursor to the mouse location as tracked by the stage, and return true if the
 *  cursor is currently visible on-stage.
 */
AhaCursor.prototype.updatePosition =
    function (stage) {
        /*  IF the cursor is mounted: update visibility and position of cursor, return whether visible
            ELSE return FALSE
         */
        if (this.mounted) {
            /*  IF the pointer is in bounds: 1) Make sure cursor is un-hidden; 2) Update its location; 3) Return TRUE
                ELSE 1) Make sure cursor is hidden; 2) Return FALSE
             */
            if (this.stage.mouseInBounds) {
                if (this.hidden)
                    this.setVisibility(this.usePointer);

                if (this.changed())
                    this.put(stage.mouseX, stage.mouseY);

                return true;
            }
            else if (!this.hidden)
                this.setVisibility(false);
        }

        return false;
    };

/** objCursor - Return the slug for the game cursor applicable to the given display object
 */
AhaCursor.prototype.objCursor =
    function (dob) {
        if (typeof dob == 'object' && !Aha.empty(dob.gameCursor))
            return dob.gameCursor;
        else
            return 'default';
    };

/** enableVisibility - Set whether the cursor is in use or is being suppressed for mobile; and update visibility.
 */
AhaCursor.prototype.enableVisibility =
    function (state) {
        this.usePointer = state;
        this.activateVisibility();
    };

/** setVisibility - Set whether the cursor should be visible (because in bounds) or otherwise
 */
AhaCursor.prototype.setVisibility =
    function (state) {
        this.hidden = !state;
        this.activateVisibility();
    };

/** activateVisibility - Show the cursor sprite if .usePointer and not .hidden
 */
AhaCursor.prototype.activateVisibility =
    function () {
        /* If the sprite object has been created (hence mountable), update its alpha property */
        if (this.mountable())
            this.finger.alpha = !this.usePointer || this.hidden ? 0 : 1;
    };

/** mountable - Return whether the sprite display object has been created
 */
AhaCursor.prototype.mountable =
    function () {
        return !Aha.empty(this.finger);
    };

/** mount - Add the cursor as a top layer on the given stage, and return whether mounted successfully.
 */
AhaCursor.prototype.mount =
    function (stage) {
        /* Report false if not mountable (no display object) */
        if (!this.mountable())
            return false;

        /* If already mounted, report true if on the requested stage, false if on another */
        if (this.mounted)
            return this.stage === stage;

        /* .stage - Reference to the stage on which the cursor is being mounted */
        this.stage = stage;

        /* prior - The slug of the cursor displaying until now (used in closure below) */
        var prior = '';

        /* Add the cursor sprite to the stage */
        stage.addChild(this.finger);

        /* Set the visibility of the cursor sprite as required for pointer location and device capability */
        this.activateVisibility();

        /* .fingerFunction - Tick event listener, switch cursor image if needed for object under pointer */
        this.fingerFunction = createjs.Ticker.addEventListener('tick',
            function (event) {
                /*  Skip if the timer is "paused" (tick events happen anyway), or if the stage pointer has not moved */
                if (!event.paused && this.updatePosition(stage)) {
                    /* Get the display object under the pointer, checking only objects with active mouse listeners (mode 2) */
                    var dob = stage.getObjectUnderPoint(this.x, this.y, 2);

                    if (dob) {
                        /* Set the cursor image only if the slug has changed */ 
                        if (dob.name != prior) {
                            prior = dob.name;
                            this.finger.gotoAndPlay(this.objCursor(dob));
                        }
                    }
                }
            }.bind(this)
        );

        return (this.mounted = true);
    };

/** unmount - Remove the cursor from the stage it is mounted on and cancel the tick event
 */
AhaCursor.prototype.unmount =
    function () {
        if (this.mounted) {
            createjs.Ticker.removeEventListener('tick', this.fingerFunction);
            
            this.stage.removeChild(this.finger);
            this.fingerFunction = null;
            this.stage = null;
            this.mounted = false;
            this.update = false;
        }
    };

/** resetPosition - Force cursor to update (if mounted) by setting the .update flag and updating the stage.
 */
AhaCursor.prototype.resetPosition =
    function () {
        if (this.mounted) {
            this.update = true;
            this.stage.update();
        }
    };

/** set - Change to the given display object's cursor, or to an overriding cursor if specified
 */
AhaCursor.prototype.set =
    function (dob, csr) {
        if (this.mounted) {
            this.finger.gotoAndPlay(csr || dob.gameCursor || 'default');
            this.resetPosition();
        }
    };
